import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import { FormatPrice } from 'utils/format';
import { Spacer, Tag, Tooltip, Icon } from '@ontruck/orc';

import { CopyableText } from 'modules/Common/Copy';

import { StyledTag } from './styled';

const t = {
  new: 'FTB',
  cancelled: 'Cancelled',
  insured: 'Insured',
  insured_for: 'Insured for',
};

const ShipperOrderTag = ({
  intl,
  insuredFor,
  currency,
  id,
  shipper,
  status,
  isRecurring,
  shipperOrdersSkin = {},
  copiable = true,
  withinGroupage = false,
  ...props
}) => {
  const insured = insuredFor > 0;
  const idText = `${intl.messages.prefixes.shipperorder_id}${id}`;
  return (
    <Spacer {...props}>
      <StyledTag
        skin={shipperOrdersSkin[id]}
        noWrapAndOverflow
        withinGroupage={withinGroupage}
        {...props}
      >
        {withinGroupage && <span className="pill" />}
        {copiable ? <CopyableText text={idText} /> : idText} {}
        {isRecurring && (
          <Spacer mLeft="XS">
            <Icon glyph="repeat" size="1.6rem" color="greyWolf" />
          </Spacer>
        )}{' '}
        {}
        {}{' '}
        {status === 'CANCELLED' && (
          <Tag skin="dark" size="S" weight="bold" textTransform="uppercase" mLeft="XS">
            {t.cancelled}
          </Tag>
        )}{' '}
        {}{' '}
        {insured && (
          <Spacer mLeft="XS">
            <Tooltip
              component={
                <Fragment>
                  {t.insured_for}{' '}
                  <FormatPrice value={insuredFor} minimumFractionDigits={0} currency={currency} />
                </Fragment>
              }
              position="top"
              skin="light"
            >
              <Tag skin="dark" size="S" weight="bold" textTransform="uppercase">
                {t.insured}
              </Tag>
            </Tooltip>
          </Spacer>
        )}
      </StyledTag>
    </Spacer>
  );
};

ShipperOrderTag.propTypes = {
  intl: PropTypes.object.isRequired,
  id: PropTypes.number,
  shipper: PropTypes.object,
  status: PropTypes.string,
  insuredFor: PropTypes.number,
  currency: PropTypes.string,
  shipperOrdersSkin: PropTypes.object.isRequired,
  isRecurring: PropTypes.bool,
  copiable: PropTypes.bool,
  withinGroupage: PropTypes.bool,
};

ShipperOrderTag.defaultProps = {
  isRecurring: false,
  copiable: true,
};

export default injectIntl(ShipperOrderTag);
